import { DEFAULT_HOTEL_HOME_PAGE_ID, DEFAULT_HOTEL_HOME_PAGE_NAME } from 'src/common/constants/pages';
import { meta } from 'utils/meta';
import loadable from '@loadable/component';
export class HotelHomeController {
  constructor() {
    this.bundles = ['hotel-home'];
    // @ts-ignore
    this.component = loadable({
      resolved: {},
      chunkName() {
        return "hotel-home";
      },
      isReady(props) {
        const key = this.resolve(props);
        if (this.resolved[key] !== true) {
          return false;
        }
        if (typeof __webpack_modules__ !== 'undefined') {
          return !!__webpack_modules__[key];
        }
        return false;
      },
      importAsync: () => import( /* webpackChunkName: "hotel-home" */'views/hotel/home.tsx'),
      requireAsync(props) {
        const key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(resolved => {
          this.resolved[key] = true;
          return resolved;
        });
      },
      requireSync(props) {
        const id = this.resolve(props);
        if (typeof __webpack_require__ !== 'undefined') {
          return __webpack_require__(id);
        }
        return eval('module.require')(id);
      },
      resolve() {
        if (require.resolveWeak) {
          return require.resolveWeak("views/hotel/home.tsx");
        }
        return eval('require.resolve')("views/hotel/home.tsx");
      }
    });
    this.pageId = DEFAULT_HOTEL_HOME_PAGE_ID;
    this.path = '/(Hotels|Hotel|overseas-hotel|domestic|Hoteles|Hoteis|hotels-HK|Hoteller|Hotellit|Hotell)';
    this.exact = false;
    this.routeName = 'hotel-home';
    this.routeData = {
      rfrrNamespace: 'HP.RB.HOTEL',
      pageName: DEFAULT_HOTEL_HOME_PAGE_NAME
    };
  }
  fetch(options) {
    const {
      stores
    } = options;
    const context = stores && stores.get('context');
    const page = stores && stores.get('page');
    return Promise.resolve().then(() => page.fetch(meta['hotel-home'], context.site, context.locale));
  }
  fetchPageData() {
    return Promise.resolve({
      title: ''
    });
  }
}